import qs from "qs";

export default function contentUrl(url, params = {}) {
  if (!url) return url;
  const [beforeHash, hash] = url.split("#");
  const [path, query = ""] = beforeHash.split("?");
  const q = qs.stringify(
    { ...qs.parse(query), ...params },
    { addQueryPrefix: true, skipNulls: true }
  );
  return `${path}${q}${hash !== undefined ? `#${hash}` : ""}`;
}
